// src/resources/predicates/PredicateList.js
import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    FunctionField,
    TextInput,
} from 'react-admin';
import { Typography } from '@mui/material';
import { useResourceSearchFilter } from '../../hooks/useResourceSearch';

const predicateFilters = [
    <TextInput key="q" source="q" label="Recherche" alwaysOn resettable />,
];

const truncate = (value, length = 160) => {
    if (!value) return '';
    if (value.length <= length) return value;
    return `${value.slice(0, length - 1)}…`;
};

const renderDescription = (record) => {
    if (!record?.description) {
        return <Typography variant="body2">—</Typography>;
    }
    return (
        <Typography variant="body2" sx={{ maxWidth: 480 }}>
            {truncate(record.description, 200)}
        </Typography>
    );
};

const renderNumericId = (record) => record?.numericId ?? record?.internalId ?? record?.dbId ?? record?.id ?? '—';

export default function PredicateList() {
    const searchFilter = useResourceSearchFilter('predicates');

    return (
        <List
            resource="predicates"
            exporter={false}
            perPage={50}
            sort={{ field: 'shortPredicate', order: 'ASC' }}
            filters={predicateFilters}
            filter={searchFilter}
            title="Liste des prédicats"
        >
            <Datagrid bulkActionButtons={false}>
                <FunctionField label="ID" render={renderNumericId} />
                <TextField source="shortPredicate" label="Code" />
                <TextField source="predicate" label="Libellé" />
                <TextField source="uri" label="URI" emptyText="—" />
                <FunctionField label="Description" render={renderDescription} />
                <TextField source="user.username" label="Créé par" emptyText="—" />
            </Datagrid>
        </List>
    );
}
